module.exports = {
	"ru": {
		"nextBtn": "Далее",
		"prevBtn": "Назад",
		"doneBtn": "Готово",
		"skipBtn": "Пропустить",
		"closeTooltip": "Закрыть"
	},
	"en": {
		"nextBtn": "Next",
		"prevBtn": "Previous",
		"doneBtn": "Done",
		"skipBtn": "Skip",
		"closeTooltip": "Close"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/tour/i18n.json
 ** module id = 12
 ** module chunks = 0
 **/